import React, { useEffect } from 'react';
import './ShoppingCart.css';
import StripeCheckout from './StripeCheckout';

const ShoppingCart = ({ cartItems, removeFromCart, updateQuantity, closeCart }) => {
  // Prevent scrolling when cart is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
  
  const calculateTotal = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0).toFixed(2);
  };

  return (
    <div className="shopping-cart">
      <div className="cart-header">
        <h2>Your Cart</h2>
        <button className="close-cart" onClick={closeCart}>×</button>
      </div>
      
      {cartItems.length === 0 ? (
        <div className="empty-cart">
          <p>Your cart is empty</p>
        </div>
      ) : (
        <>
          <div className="cart-items">
            {cartItems.map((item) => (
              <div className="cart-item" key={`${item.id}-${item.size || 'default'}`}>
                <div className="item-details">
                  <h3>{item.name}</h3>
                  {item.size && <p className="item-size">Size: {item.size}</p>}
                  <p className="item-price">${item.price.toFixed(2)}</p>
                </div>
                <div className="item-actions">
                  <div className="quantity-control">
                    <button 
                      onClick={() => updateQuantity(item.id, item.quantity - 1, item.size)}
                      disabled={item.quantity <= 1}
                    >
                      -
                    </button>
                    <span>{item.quantity}</span>
                    <button onClick={() => updateQuantity(item.id, item.quantity + 1, item.size)}>
                      +
                    </button>
                  </div>
                  <button 
                    className="remove-item" 
                    onClick={() => removeFromCart(item.id, item.size)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div className="cart-footer">
            <div className="cart-total">
              <span>Total:</span>
              <span>${calculateTotal()}</span>
            </div>
            <StripeCheckout cartItems={cartItems} />
          </div>
        </>
      )}
    </div>
  );
};

export default ShoppingCart;
